<div class="day-stats" *ngIf="!loading && statistics">
  <div class="stats-grid">
    <!-- Колонка Заявки -->
    <div class="stats-column">
      <div class="column-header">Заявки</div>
      <div class="stats-item">
        <span class="item-label">Подключения</span>
        <span class="item-value">{{ connectionTickets }}</span>
      </div>
      <div class="stats-item">
        <span class="item-label">Дозаказы</span>
        <span class="item-value">{{ additionalOrders }}</span>
      </div>
      <div class="stats-item">
        <span class="item-label">Локальные заявки</span>
        <span class="item-value">{{ localApplications }}</span>
      </div>
      <div class="stats-item">
        <span class="item-label">Глобальные проблемы</span>
        <span class="item-value">{{ globalProblems }}</span>
      </div>
      <div class="stats-item stats-item--total">
        <span class="item-label">Всего</span>
        <span class="item-value">{{ totalTickets }}</span>
      </div>
    </div>

    <!-- Колонка Часы -->
    <div class="stats-column" *ngIf="hasWorkloadData">
      <div class="column-header">Часы</div>
      <div class="stats-item">
        <span class="item-label">Заложено</span>
        <span class="item-value">{{ totalHours }} ч.</span>
      </div>
      <div class="stats-item">
        <span class="item-label">Занято</span>
        <span class="item-value">{{ busyHours }} ч.</span>
      </div>
      <div class="stats-item">
        <span class="item-label">Не использовано</span>
        <span class="item-value">{{ unusedHours }} ч.</span>
      </div>
    </div>
  </div>
</div>

<div class="stats-loading" *ngIf="loading">
  <app-loader></app-loader>
  <span class="color-gray-dark">Загрузка статистики...</span>
</div>

<div class="stats-empty" *ngIf="!loading && !statistics">
  <span class="color-gray-dark">Нет данных за выбранный день</span>
</div>
